import { ChangeDetectionStrategy, Component, OnDestroy } from '@angular/core';
import { PageTemplateTypes } from '@shared/page/page.component';
import { Subpages } from '@modules/reports/models/subpages';
import { Page } from '@shared/nav-left/pages';
import { MojoFeatureExtensionsService } from 'mojo-feature-extensions';
import { Subscription } from 'rxjs';
import { AppFeatureExtensions } from '@app/app-feature-extensions.config';

@Component({
  selector: 'mojo-reports-page',
  templateUrl: './reports-page.container.html',
  styleUrls: ['./reports-page.container.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ReportsPageContainerComponent implements OnDestroy {
  subs = new Subscription();
  templateType = PageTemplateTypes.twoColumns;
  pages: Page[];

  constructor(private mojoFeatureExtensionsService: MojoFeatureExtensionsService) {
    //TEMPORARY FEATURE EXTENSION IN ORDER TO HIDE SOME NOT FINISHED FEATURE BEFORE RELEASE
    this.subs.add(
      this.mojoFeatureExtensionsService
        .hasFeatureExtension(AppFeatureExtensions.REFERRAL_WHOLE_FLOW)
        .subscribe((hasFeatureExtension) => {
          this.pages = !!hasFeatureExtension
            ? [
                {
                  title: 'Dashboard',
                  link: Subpages.DASHBOARD,
                },
                {
                  title: 'Pipeline',
                  link: Subpages.PIPELINE,
                },
                {
                  title: 'Referral Report',
                  link: Subpages.REFERRAL_REPORT,
                },
              ]
            : [
                {
                  title: 'Pipeline',
                  link: Subpages.PIPELINE,
                },
                {
                  title: 'Referral Report',
                  link: Subpages.REFERRAL_REPORT,
                },
              ];
        }),
    );
  }

  ngOnDestroy() {
    this.subs.unsubscribe();
  }
}
